import { Loader } from '@nordlayer/rivendell-ui';
import loadable from '@nordvpn/teams.core/lib/tools/loadable';
import { RouteGenerator } from 'routing/RouteGenerator';
import { useAreFeaturesLoaded } from 'api/FeatureFlags/queries';
import { CREATE_USER_PASSWORD_INVITATION_PATH, USERS_MANAGEMENT_PATH } from './constants';
import { jsx as _jsx } from "react/jsx-runtime";
var UsersManagementOld = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/UsersManagementRouteOld');
});
var CreatePasswordInvitation = loadable(function () {
    return import(/* webpackPrefetch: true */ 'utils/lazy/entry/Pages/CreatePasswordInvitation');
});
var UsersManagementPage = function UsersManagementPage() {
    var areFeaturesLoaded = useAreFeaturesLoaded();
    if (!areFeaturesLoaded) {
        return /*#__PURE__*/ _jsx(Loader, {
            centered: true
        });
    }
    return /*#__PURE__*/ _jsx(UsersManagementOld, {});
};
export var UsersManagementOldRouting = function UsersManagementOldRouting() {
    return RouteGenerator({
        root: {
            path: USERS_MANAGEMENT_PATH,
            component: UsersManagementPage
        }
    });
};
export var createUserPasswordInvitationRoute = [{
        pathname: CREATE_USER_PASSWORD_INVITATION_PATH,
        component: CreatePasswordInvitation
    }];
